<template>
  <a-modal
    title="Shift Deletion"
    :visible="visible"
    :closable="false"
    @cancel="closeDeletionModal"
    :destroy-on-close="true"
  >
    <div>Are you sure you want to delete shift #{{ shiftId }}?</div>
    <template slot="footer">
      <div class="flex justify-content-between">
        <a-button @click="closeDeletionModal">Cancel</a-button>
        <div class="flex gap-2">
          <a-button :loading="loading" type="danger" @click="handleDeletion">Delete Shift</a-button>
        </div>
      </div>
    </template>
  </a-modal>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { Button, notification } from 'ant-design-vue'

const { mapState, mapActions } = createNamespacedHelpers('shifts')

export default {
  components: {
    'a-button': Button
  },
  props: {
    shiftId: {
      type: Number
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapState({
      shift: state => state.shift.shift
    }),

    canBeDeleted() {
      const paymentStatuses = ['unpaid', 'cancelled', 'not_paid']

      const shiftStatuses = ['scheduled', 'missed', 'cancelled', 'completed']

      return (
        paymentStatuses.includes(this.shift.internal_payment_info.payment_status) &&
        shiftStatuses.includes(this.shift.status)
      )
    }
  },
  methods: {
    ...mapActions(['deleteShift']),

    showNotification(type, message, description) {
      notification[type]({
        message,
        description
      })
    },

    closeDeletionModal() {
      this.$emit('update:visible', false)
    },

    async handleDeletion() {
      if (!this.canBeDeleted) {
        this.showNotification(
          'warning',
          'Waning',
          "This shift can't be deleted cause of shift status or payment status"
        )
        this.closeDeletionModal()

        return
      }

      this.loading = true
      try {
        await this.deleteShift({ shift_id: this.shiftId })
        this.$emit('edit')
        this.showNotification('success', 'Success', `Shift #${this.shiftId} has been successfully deleted`)
        this.closeDeletionModal()
      } catch (error) {
        this.showNotification('error', 'Error', typeof error === 'string' ? error : error?.message)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
